<template>
  <v-container fluid class="antecedentes-container pa-0">
    <v-card class="mx-auto main-card" elevation="10">
      <v-app-bar flat dark class="gradient-header">
        <v-toolbar-title class="text-h5 font-weight-bold">
          Sistema Integrado de Consulta 
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDarkMode">
          <v-icon>{{ darkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
        </v-btn>
        <v-btn icon @click="showHelp">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
        <v-btn icon @click="exportData">
          <v-icon>mdi-export</v-icon>
        </v-btn>
      </v-app-bar>

      <v-tabs
        v-model="activeTab"
        background-color="primary"
        dark
        grow
        slider-color="secondary"
      >
        <v-tab>
          <v-icon left>mdi-account-search</v-icon>
          Personas
        </v-tab>
        <v-tab>
          <v-icon left>mdi-car-search</v-icon>
          Vehículos
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- Pestaña de Búsqueda de Personas -->
        <v-tab-item>
          <v-card flat class="tab-card">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-card class="search-card" elevation="5">
                    <v-card-title class="search-title">
                      <v-icon large left color="primary">mdi-account-search</v-icon>
                      Búsqueda de Personas
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="personaForm">
                        <v-tabs v-model="searchTypeTab" grow>
                          <v-tab>
                            <v-icon small left>mdi-card-account-details</v-icon>
                            DNI
                          </v-tab>
                          <v-tab>
                            <v-icon small left>mdi-account</v-icon>
                            Nombre
                          </v-tab>
                        </v-tabs>
                        
                        <v-tabs-items v-model="searchTypeTab" class="mt-3">
                          <v-tab-item>
                            <v-text-field
                              v-model="dni"
                              label="Número de DNI"
                              outlined
                              dense
                              clearable
                              prepend-inner-icon="mdi-card-account-details"
                              color="primary"
                              :rules="[v => !!v || 'DNI es requerido', v => /^\d+$/.test(v) || 'DNI debe contener solo números']"
                            ></v-text-field>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row dense>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="nombre"
                                  label="Nombre"
                                  outlined
                                  dense
                                  clearable
                                  prepend-inner-icon="mdi-account"
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="apellido"
                                  label="Apellido"
                                  outlined
                                  dense
                                  clearable
                                  prepend-inner-icon="mdi-account"
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                        </v-tabs-items>
                        
                        <v-select
                          v-model="baseDeDatos"
                          :items="basesDeDatos"
                          label="Base de Datos"
                          outlined
                          dense
                          chips
                          multiple
                          prepend-inner-icon="mdi-database-search"
                          color="primary"
                          class="mt-3"
                        ></v-select>
                        
                        <v-btn 
                          @click="buscarAntecedentes" 
                          color="primary" 
                          :loading="loading"
                          :disabled="!validarBusquedaPersona()"
                          block
                          class="mt-3 search-button"
                        >
                          <v-icon left>mdi-magnify</v-icon> Buscar
                        </v-btn>
                      </v-form>
                      
                      <v-divider class="my-4"></v-divider>
                      
                      <v-expansion-panels v-if="!loading && resultados" accordion flat class="filters-panel">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="filters-header">
                            <v-icon left color="primary">mdi-filter-variant</v-icon>
                            Filtros Avanzados
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row dense>
                              <v-col cols="12">
                                <v-select
                                  v-model="filtroTipoAntecedente"
                                  :items="tiposAntecedentes"
                                  label="Tipo de Antecedente"
                                  outlined
                                  dense
                                  multiple
                                  chips
                                  small-chips
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="filtroEstado"
                                  :items="estados"
                                  label="Estado"
                                  outlined
                                  dense
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="menuFechaDesde"
                                  v-model="menuFechaDesde"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template #activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="fechaDesde"
                                      label="Fecha Desde"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="fechaDesde"
                                    @input="menuFechaDesde = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                </v-col>
                
                <v-col cols="12" md="8">
                  <v-card v-if="loading" class="loading-card" elevation="0">
                    <v-card-text class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="70"
                        width="7"
                      ></v-progress-circular>
                      <div class="text-h6 mt-4">Buscando información...</div>
                      <div class="text-body-2 text-medium-emphasis">Consultando bases de datos</div>
                      <v-progress-linear
                        indeterminate
                        color="primary"
                        class="mt-4"
                      ></v-progress-linear>
                    </v-card-text>
                  </v-card>
                  
                  <transition name="fade" mode="out-in">
                    <v-card v-if="!loading && resultados" class="results-card" elevation="5">
                      <v-card-title class="results-title">
                        <v-avatar size="42" class="mr-3">
                          <v-img src="https://randomuser.me/api/portraits/men/1.jpg"></v-img>
                        </v-avatar>
                        Resultados de la Búsqueda
                        <v-spacer></v-spacer>
                        <v-chip color="success" small>Coincidencia: 98%</v-chip>
                      </v-card-title>
                      
                      <v-tabs v-model="resultTab" background-color="transparent" color="primary" grow>
                        <v-tab>
                          <v-icon small left>mdi-account-details</v-icon>
                          Datos Personales
                        </v-tab>
                        <v-tab>
                          <v-icon small left>mdi-file-document-multiple</v-icon>
                          Antecedentes
                        </v-tab>
                        <v-tab>
                          <v-icon small left>mdi-chart-bar</v-icon>
                          Estadísticas
                        </v-tab>
                      </v-tabs>
                      
                      <v-tabs-items v-model="resultTab">
                        <!-- Pestaña de Datos Personales -->
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <v-card outlined class="bio-card">
                                    <v-img
                                      height="200"
                                      src="https://randomuser.me/api/portraits/men/1.jpg"
                                      class="white--text align-end"
                                      gradient="to bottom, rgba(0,0,0,0) 60%, rgba(0,0,0,0.8)"
                                    >
                                      <v-card-title>Juan Pérez</v-card-title>
                                    </v-img>
                                    <v-card-text>
                                      <v-list dense>
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-card-account-details</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>DNI: {{ dni }}</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-calendar</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Edad: 35 años</v-list-item-title>
                                            <v-list-item-subtitle>Nacido: 15/05/1990</v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-home</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Domicilio: Calle Falsa 123</v-list-item-title>
                                            <v-list-item-subtitle>Capital, San Juan</v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                
                                <v-col cols="12" md="8">
                                  <v-card outlined class="info-card">
                                    <v-card-title class="info-title">
                                      <v-icon left color="primary">mdi-information</v-icon>
                                      Información Adicional
                                    </v-card-title>
                                    <v-card-text>
                                      <v-row>
                                        <v-col cols="12" md="6">
                                          <v-list dense>
                                            <v-subheader>Datos Familiares</v-subheader>
                                            <v-list-item>
                                              <v-list-item-icon>
                                                <v-icon small>mdi-account</v-icon>
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title>Padre: Carlos Pérez</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                              <v-list-item-icon>
                                                <v-icon small>mdi-account</v-icon>
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title>Madre: Ana López</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                              <v-list-item-icon>
                                                <v-icon small>mdi-account-multiple</v-icon>
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title>Estado Civil: Casado</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                        
                                        <v-col cols="12" md="6">
                                          <v-list dense>
                                            <v-subheader>Datos de Contacto</v-subheader>
                                            <v-list-item>
                                              <v-list-item-icon>
                                                <v-icon small>mdi-phone</v-icon>
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title>Teléfono: (264) 555-1234</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                              <v-list-item-icon>
                                                <v-icon small>mdi-email</v-icon>
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title>Email: juan.perez@example.com</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                              <v-list-item-icon>
                                                <v-icon small>mdi-briefcase</v-icon>
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title>Ocupación: Comerciante</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                      </v-row>
                                      
                                      <v-divider class="my-3"></v-divider>
                                      
                                      <v-alert
                                        color="info"
                                        border="left"
                                        colored-border
                                        elevation="2"
                                        class="mb-0"
                                      >
                                        <div class="text-subtitle-1 font-weight-medium">Observaciones</div>
                                        <div class="text-body-2">Persona con restricciones para salir del país. Debe presentarse mensualmente en el juzgado N°3.</div>
                                      </v-alert>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        
                        <!-- Pestaña de Antecedentes -->
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-timeline dense>
                                <v-timeline-item
                                  v-for="(antecedente, i) in antecedentes"
                                  :key="i"
                                  :color="antecedente.color"
                                  small
                                >
                                  <template #opposite>
                                    <span
                                      :class="`font-weight-bold ${antecedente.color}--text`"
                                      v-text="antecedente.fecha"
                                    ></span>
                                  </template>
                                  <v-card class="elevation-1">
                                    <v-card-title class="text-subtitle-1">
                                      {{ antecedente.tipo }}
                                      <v-spacer></v-spacer>
                                      <v-chip
                                        small
                                        :color="antecedente.estadoColor"
                                        text-color="white"
                                      >
                                        {{ antecedente.estado }}
                                      </v-chip>
                                    </v-card-title>
                                    <v-card-text>
                                      <div class="text-caption mb-2">
                                        <v-icon x-small>mdi-map-marker</v-icon>
                                        {{ antecedente.lugar }}
                                      </div>
                                      <div>{{ antecedente.descripcion }}</div>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        small
                                        color="primary"
                                        @click="verDetalleAntecedente(antecedente)"
                                      >
                                        <v-icon small left>mdi-eye</v-icon>
                                        Ver detalles
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-timeline-item>
                              </v-timeline>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        
                        <!-- Pestaña de Estadísticas -->
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-card outlined>
                                    <v-card-title>Tipos de Antecedentes</v-card-title>
                                    <v-card-text>
                                      <apexchart
                                        type="donut"
                                        height="300"
                                        :options="chartOptions.donut"
                                        :series="series.donut"
                                      ></apexchart>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                
                                <v-col cols="12" md="6">
                                  <v-card outlined>
                                    <v-card-title>Evolución Temporal</v-card-title>
                                    <v-card-text>
                                      <apexchart
                                        type="line"
                                        height="300"
                                        :options="chartOptions.line"
                                        :series="series.line"
                                      ></apexchart>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                
                                <v-col cols="12">
                                  <v-card outlined>
                                    <v-card-title>Análisis de Riesgo</v-card-title>
                                    <v-card-text>
                                      <v-row>
                                        <v-col cols="12" md="4" v-for="(riesgo, i) in riesgos" :key="i">
                                          <v-card class="mx-auto" max-width="400">
                                            <v-card-text class="text-center">
                                              <v-progress-circular
                                                :rotate="-90"
                                                :size="100"
                                                :width="15"
                                                :value="riesgo.valor"
                                                :color="riesgo.color"
                                              >
                                                {{ riesgo.valor }}%
                                              </v-progress-circular>
                                              <div class="text-h6 mt-3">{{ riesgo.tipo }}</div>
                                              <div class="text-caption">{{ riesgo.descripcion }}</div>
                                            </v-card-text>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </transition>
                  
                  <v-card v-if="!loading && !resultados" class="no-results-card" elevation="0">
                    <v-card-text class="text-center">
                      <v-img
                        src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                        height="200"
                        contain
                        class="mb-4"
                      ></v-img>
                      <div class="text-h5 mb-2">Sin resultados</div>
                      <div class="text-body-1 text-medium-emphasis mb-4">
                        Ingrese los datos de búsqueda para consultar antecedentes.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        
        <!-- Pestaña de Búsqueda de Vehículos -->
        <v-tab-item>
          <v-card flat class="tab-card">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-card class="search-card" elevation="5">
                    <v-card-title class="search-title">
                      <v-icon large left color="primary">mdi-car-search</v-icon>
                      Búsqueda de Vehículos
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="vehiculoForm">
                        <v-tabs v-model="searchTypeVehiculoTab" grow>
                          <v-tab>
                            <v-icon small left>mdi-car</v-icon>
                            Patente
                          </v-tab>
                          <v-tab>
                            <v-icon small left>mdi-account</v-icon>
                            Titular
                          </v-tab>
                        </v-tabs>
                        
                        <v-tabs-items v-model="searchTypeVehiculoTab" class="mt-3">
                          <v-tab-item>
                            <v-text-field
                              v-model="patente"
                              label="Número de Patente"
                              outlined
                              dense
                              clearable
                              prepend-inner-icon="mdi-car"
                              color="primary"
                              :rules="[v => !!v || 'Patente es requerida']"
                            ></v-text-field>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row dense>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="nombreTitular"
                                  label="Nombre del Titular"
                                  outlined
                                  dense
                                  clearable
                                  prepend-inner-icon="mdi-account"
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="dniTitular"
                                  label="DNI del Titular"
                                  outlined
                                  dense
                                  clearable
                                  prepend-inner-icon="mdi-card-account-details"
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                        </v-tabs-items>
                        
                        <v-row dense class="mt-3">
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="marca"
                              :items="marcas"
                              label="Marca"
                              outlined
                              dense
                              clearable
                              prepend-inner-icon="mdi-car-info"
                              color="primary"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              v-model="modelo"
                              :items="modelos"
                              label="Modelo"
                              outlined
                              dense
                              clearable
                              prepend-inner-icon="mdi-car-side"
                              color="primary"
                            ></v-select>
                          </v-col>
                        </v-row>
                        
                        <v-btn 
                          @click="buscarVehiculo" 
                          color="primary" 
                          :loading="loadingVehiculo"
                          :disabled="!validarBusquedaVehiculo()"
                          block
                          class="mt-3 search-button"
                        >
                          <v-icon left>mdi-magnify</v-icon> Buscar
                        </v-btn>
                      </v-form>
                      
                      <v-divider class="my-4"></v-divider>
                      
                      <v-expansion-panels v-if="!loadingVehiculo && resultadosVehiculo" accordion flat class="filters-panel">
                        <v-expansion-panel>
                          <v-expansion-panel-header class="filters-header">
                            <v-icon left color="primary">mdi-filter-variant</v-icon>
                            Filtros Avanzados
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row dense>
                              <v-col cols="12">
                                <v-select
                                  v-model="filtroEstadoVehiculo"
                                  :items="estadosVehiculo"
                                  label="Estado del Vehículo"
                                  outlined
                                  dense
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="filtroTipoMovimiento"
                                  :items="tiposMovimiento"
                                  label="Tipo de Movimiento"
                                  outlined
                                  dense
                                  multiple
                                  chips
                                  small-chips
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="menuFechaDesdeVehiculo"
                                  v-model="menuFechaDesdeVehiculo"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template #activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="fechaDesdeVehiculo"
                                      label="Fecha Desde"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="fechaDesdeVehiculo"
                                    @input="menuFechaDesdeVehiculo = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                </v-col>
                
                <v-col cols="12" md="8">
                  <v-card v-if="loadingVehiculo" class="loading-card" elevation="0">
                    <v-card-text class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="70"
                        width="7"
                      ></v-progress-circular>
                      <div class="text-h6 mt-4">Buscando información del vehículo...</div>
                      <div class="text-body-2 text-medium-emphasis">Consultando bases de datos</div>
                      <v-progress-linear
                        indeterminate
                        color="primary"
                        class="mt-4"
                      ></v-progress-linear>
                    </v-card-text>
                  </v-card>
                  
                  <transition name="fade" mode="out-in">
                    <v-card v-if="!loadingVehiculo && resultadosVehiculo" class="results-card" elevation="5">
                      <v-card-title class="results-title">
                        <v-avatar size="42" class="mr-3 car-avatar">
                          <v-icon size="32">mdi-car</v-icon>
                        </v-avatar>
                        Resultados de la Búsqueda
                        <v-spacer></v-spacer>
                        <v-chip color="error" small v-if="vehiculoCapturado">CAPTURA ACTIVA</v-chip>
                      </v-card-title>
                      
                      <v-tabs v-model="resultVehiculoTab" background-color="transparent" color="primary" grow>
                        <v-tab>
                          <v-icon small left>mdi-car-info</v-icon>
                          Datos del Vehículo
                        </v-tab>
                        <v-tab>
                          <v-icon small left>mdi-map-marker-path</v-icon>
                          Movimientos
                        </v-tab>
                        <v-tab>
                          <v-icon small left>mdi-alert-circle</v-icon>
                          Alertas
                        </v-tab>
                      </v-tabs>
                      
                      <v-tabs-items v-model="resultVehiculoTab">
                        <!-- Pestaña de Datos del Vehículo -->
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <v-card outlined class="bio-card">
                                    <v-img
                                      height="200"
                                      src="https://ecoautoparts-prod-frontend-bucket.s3.amazonaws.com/vehiculos/FVE480/fotografias/4.webp"
                                   
                                      class="white--text align-end"
                                      gradient="to bottom, rgba(0,0,0,0) 60%, rgba(0,0,0,0.8)"
                                    >
                                      <v-card-title>{{ marca }} {{ modelo }}</v-card-title>
                                    </v-img>
                                    <v-card-text>
                                      <v-list dense>
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-car</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Patente: {{ patente }}</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-calendar</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Año: 2018</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-palette</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Color: Gris</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                
                                <v-col cols="12" md="8">
                                  <v-card outlined class="info-card">
                                    <v-card-title class="info-title">
                                      <v-icon left color="primary">mdi-account</v-icon>
                                      Datos del Titular
                                    </v-card-title>
                                    <v-card-text>
                                      <v-list dense>
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-account</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Nombre: Carlos Gómez</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-card-account-details</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>DNI: 28456789</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-home</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Domicilio: Av. Libertador 1234</v-list-item-title>
                                            <v-list-item-subtitle>Rivadavia, San Juan</v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                          <v-list-item-icon>
                                            <v-icon color="primary">mdi-phone</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                            <v-list-item-title>Teléfono: (264) 555-9876</v-list-item-title>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                      
                                      <v-divider class="my-3"></v-divider>
                                      
                                      <v-alert
                                        v-if="vehiculoCapturado"
                                        color="error"
                                        border="left"
                                        colored-border
                                        elevation="2"
                                        class="mb-0"
                                      >
                                        <div class="text-subtitle-1 font-weight-medium">ALERTA DE CAPTURA</div>
                                        <div class="text-body-2">Vehículo con pedido de captura activo por causa de robo. Orden judicial N° 2023/789 del Juzgado Federal N°2.</div>
                                      </v-alert>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        
                        <!-- Pestaña de Movimientos -->
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-timeline dense>
                                <v-timeline-item
                                  v-for="(movimiento, i) in movimientosVehiculo"
                                  :key="i"
                                  :color="movimiento.color"
                                  small
                                >
                                  <template #opposite>
                                    <span
                                      :class="`font-weight-bold ${movimiento.color}--text`"
                                      v-text="movimiento.fecha"
                                    ></span>
                                  </template>
                                  <v-card class="elevation-1">
                                    <v-card-title class="text-subtitle-1">
                                      {{ movimiento.tipo }}
                                      <v-spacer></v-spacer>
                                      <v-chip
                                        small
                                        :color="movimiento.direccion === 'Entrada' ? 'success' : 'info'"
                                        text-color="white"
                                      >
                                        {{ movimiento.direccion }}
                                      </v-chip>
                                    </v-card-title>
                                    <v-card-text>
                                      <div class="text-caption mb-2">
                                        <v-icon x-small>mdi-map-marker</v-icon>
                                        {{ movimiento.lugar }}
                                      </div>
                                      <div>{{ movimiento.descripcion }}</div>
                                    </v-card-text>
                                  </v-card>
                                </v-timeline-item>
                              </v-timeline>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        
                        <!-- Pestaña de Alertas -->
                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12">
                                  <v-alert
                                    v-if="vehiculoCapturado"
                                    color="error"
                                    border="left"
                                    colored-border
                                    elevation="2"
                                    class="mb-4"
                                  >
                                    <div class="text-h6">CAPTURA ACTIVA</div>
                                    <div class="text-subtitle-1">Motivo: Robo de vehículo</div>
                                    <div class="text-body-2 mt-2">
                                      <strong>Fecha de denuncia:</strong> 15/03/2025<br>
                                      <strong>Juzgado:</strong> Federal N°2<br>
                                      <strong>Orden judicial:</strong> N° 2023/789<br>
                                      <strong>Denunciante:</strong> María López (DNI: 27654321)
                                    </div>
                                    <v-btn
                                      color="white"
                                      text
                                      class="mt-2"
                                      @click="verDetalleCaptura"
                                    >
                                      <v-icon left>mdi-file-document</v-icon>
                                      Ver detalles completos
                                    </v-btn>
                                  </v-alert>
                                  
                                  <v-card v-if="!vehiculoCapturado" outlined class="text-center pa-4">
                                    <v-icon size="64" color="success">mdi-check-circle</v-icon>
                                    <div class="text-h6 mt-2">Sin alertas activas</div>
                                    <div class="text-body-2 text-medium-emphasis">El vehículo no presenta alertas ni pedidos de captura activos.</div>
                                  </v-card>
                                </v-col>
                                
                                <v-col cols="12" class="mt-4">
                                  <v-card outlined>
                                    <v-card-title>
                                      <v-icon left color="primary">mdi-history</v-icon>
                                      Historial de Alertas
                                    </v-card-title>
                                    <v-card-text>
                                      <v-data-table
                                        :headers="historialAlertasHeaders"
                                        :items="historialAlertas"
                                        :items-per-page="5"
                                        class="elevation-1"
                                      >
                                        <template v-slot:item="{ item }">
                                          <tr>
                                            <td>{{ item.fecha }}</td>
                                            <td>{{ item.tipo }}</td>
                                            <td>
                                              <v-chip
                                                small
                                                :color="item.estado === 'Resuelta' ? 'success' : 'error'"
                                                text-color="white"
                                              >
                                                {{ item.estado }}
                                              </v-chip>
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </transition>
                  
                  <v-card v-if="!loadingVehiculo && !resultadosVehiculo" class="no-results-card" elevation="0">
                    <v-card-text class="text-center">
                      <v-img
                        src="https://cdn.vuetifyjs.com/images/cards/road.jpg"
                        height="200"
                        contain
                        class="mb-4"
                      ></v-img>
                      <div class="text-h5 mb-2">Sin resultados</div>
                      <div class="text-body-1 text-medium-emphasis mb-4">
                        Ingrese los datos de búsqueda para consultar información de vehículos.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      
      <!-- Componente de Control San Carlos -->
      <v-card outlined class="mt-4 control-san-carlos">
        <v-card-title class="control-title">
          <v-icon left color="primary">mdi-gate</v-icon>
          Control San Carlos
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-card outlined class="patente-card">
                <v-card-title class="patente-title">
                  <v-icon left color="success">mdi-arrow-right-bold-circle</v-icon>
                  Ingreso a la Provincia
                </v-card-title>
                <v-card-text class="text-center">
                  <div class="patente-container">
                    <div class="patente-argentina">
                      <div class="patente-header">
                        <span class="mercosur">MERCOSUR</span>
                        <span class="republica">REPÚBLICA ARGENTINA</span>
                        <span class="bandera"></span>
                      </div>
                      <div class="patente-numero" :class="{'patente-alerta': patenteIngresoAlerta}">
                        <span class="letras">{{ patenteIngresoLetras1 }}</span>
                        <span class="numeros">{{ patenteIngresoNumeros }}</span>
                        <span class="letras">{{ patenteIngresoLetras2 }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- Estado de verificaciu00f3n -->
                  <v-chip
                    v-if="patenteIngresoVerificada"
                    :color="patenteIngresoAlerta ? 'error' : 'success'"
                    text-color="white"
                    class="mt-4"
                  >
                    <v-icon left v-if="patenteIngresoAlerta">mdi-alert-circle</v-icon>
                    <v-icon left v-else>mdi-check-circle</v-icon>
                    {{ patenteIngresoAlerta ? 'ALERTA! CAPTURA' : 'Verificado' }}
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-col>
            
            <v-col cols="12" md="6">
              <v-card outlined class="patente-card">
                <v-card-title class="patente-title">
                  <v-icon left color="info">mdi-arrow-left-bold-circle</v-icon>
                  Salida de la Provincia
                </v-card-title>
                <v-card-text class="text-center">
                  <div class="patente-container">
                    <div class="patente-argentina">
                      <div class="patente-header">
                        <span class="mercosur">MERCOSUR</span>
                        <span class="republica">REPÚBLICA ARGENTINA</span>
                        <span class="bandera"></span>
                      </div>
                      <div class="patente-numero" :class="{'patente-alerta': patenteSalidaAlerta}">
                        <span class="letras">{{ patenteSalidaLetras1 }}</span>
                        <span class="numeros">{{ patenteSalidaNumeros }}</span>
                        <span class="letras">{{ patenteSalidaLetras2 }}</span>
                      </div>
                    </div>
                  </div>
                  <v-chip
                    v-if="patenteSalidaVerificada"
                    :color="patenteSalidaAlerta ? 'error' : 'success'"
                    text-color="white"
                    class="mt-4"
                  >
                    <v-icon left v-if="patenteSalidaAlerta">mdi-alert-circle</v-icon>
                    <v-icon left v-else>mdi-check-circle</v-icon>
                    {{ patenteSalidaAlerta ? 'ALERTA! VEHÍCULO CON PEDIDO DE CAPTURA' : 'Vehículo verificado' }}
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'BusquedaAntecedentesView',
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      activeTab: 0,
      searchTypeTab: 0,
      resultTab: 0,
      dni: '',
      nombre: '',
      apellido: '',
      baseDeDatos: [],
      basesDeDatos: ['Registro Civil', 'Sistema Penal', 'Sistema Judicial'],
      loading: false,
      resultados: false,
      filtroTipoAntecedente: [],
      tiposAntecedentes: ['Robo', 'Asalto', 'Fraude'],
      filtroEstado: '',
      estados: ['En libertad condicional', 'Preso', 'Fugitivo'],
      fechaDesde: '',
      menuFechaDesde: false,
      antecedentes: [
        {
          fecha: '2020-01-01',
          tipo: 'Robo',
          lugar: 'Calle Falsa 123',
          descripcion: 'Robo de un vehículo',
          color: 'primary',
          estado: 'En libertad condicional',
          estadoColor: 'success'
        },
        {
          fecha: '2020-06-01',
          tipo: 'Asalto',
          lugar: 'Calle Falsa 456',
          descripcion: 'Asalto a un comercio',
          color: 'warning',
          estado: 'Preso',
          estadoColor: 'error'
        }
      ],
      series: {
        donut: [44, 55, 41],
        line: [{
          name: 'Casos',
          data: [30, 70, 45]
        }]
      },
      chartOptions: {
        donut: {
          chart: {
            type: 'donut',
            height: 300
          },
          stroke: {
            curve: 'smooth'
          },
          xaxis: {
            categories: ['Robo', 'Asalto', 'Fraude'],
          },
          yaxis: {
            title: {
              text: 'Casos'
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Casos: " + val
              }
            }
          }
        },
        line: {
          chart: {
            type: 'line',
            height: 350
          },
          stroke: {
            curve: 'smooth'
          },
          xaxis: {
            categories: ['Robo', 'Asalto', 'Fraude'],
          },
          yaxis: {
            title: {
              text: 'Casos'
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Casos: " + val
              }
            }
          }
        }
      },
      riesgos: [
        {
          tipo: 'Riesgo de fuga',
          valor: 70,
          color: 'warning',
          descripcion: 'El sujeto tiene antecedentes de fugas'
        },
        {
          tipo: 'Riesgo de violencia',
          valor: 40,
          color: 'error',
          descripcion: 'El sujeto tiene antecedentes de violencia'
        }
      ],
      searchTypeVehiculoTab: 0,
      patente: '',
      nombreTitular: '',
      dniTitular: '',
      marca: '',
      modelo: '',
      loadingVehiculo: false,
      resultadosVehiculo: false,
      filtroEstadoVehiculo: '',
      estadosVehiculo: ['Activo', 'Inactivo'],
      filtroTipoMovimiento: [],
      tiposMovimiento: ['Entrada', 'Salida'],
      fechaDesdeVehiculo: '',
      menuFechaDesdeVehiculo: false,
      resultVehiculoTab: 0,
      vehiculoCapturado: true,
      movimientosVehiculo: [
        {
          fecha: '2022-01-01',
          tipo: 'Entrada',
          lugar: 'Puerto Madero',
          descripcion: 'Ingreso al país',
          color: 'success',
          direccion: 'Entrada'
        },
        {
          fecha: '2022-06-01',
          tipo: 'Salida',
          lugar: 'Ezeiza',
          descripcion: 'Salida del país',
          color: 'info',
          direccion: 'Salida'
        }
      ],
      historialAlertasHeaders: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Estado', value: 'estado' }
      ],
      historialAlertas: [
        {
          fecha: '2022-01-01',
          tipo: 'Robo',
          estado: 'Resuelta'
        },
        {
          fecha: '2022-06-01',
          tipo: 'Asalto',
          estado: 'Pendiente'
        }
      ],
      patenteIngresoLetras1: 'ABC',
      patenteIngresoNumeros: '123',
      patenteIngresoLetras2: 'DEF',
      patenteIngresoAlerta: false,
      patenteIngresoVerificada: true,
      verificandoIngreso: false,
      patenteSalidaLetras1: 'GHI',
      patenteSalidaNumeros: '456',
      patenteSalidaLetras2: 'JKL',
      patenteSalidaAlerta: false,
      patenteSalidaVerificada: true,
    }
  },
  methods: {
    toggleDarkMode() {
      // Implementar la función para cambiar el modo oscuro
    },
    showHelp() {
      // Implementar la función para mostrar ayuda
    },
    exportData() {
      // Implementar la función para exportar datos
    },
    buscarAntecedentes() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.resultados = true;
      }, 3000);
    },
    validarBusquedaPersona() {
      if (this.searchTypeTab === 0) {
        return this.dni !== '';
      } else {
        return this.nombre !== '' && this.apellido !== '';
      }
    },
    verDetalleAntecedente(antecedente) {
      console.log('Ver detalle del antecedente:', antecedente);
    },
    buscarVehiculo() {
      this.loadingVehiculo = true;
      setTimeout(() => {
        this.loadingVehiculo = false;
        this.resultadosVehiculo = true;
      }, 3000);
    },
    validarBusquedaVehiculo() {
      if (this.searchTypeVehiculoTab === 0) {
        return this.patente !== '';
      } else {
        return this.nombreTitular !== '' && this.dniTitular !== '';
      }
    },
    verDetalleCaptura() {
      // Implementar la función para ver detalles de la captura
    },
    simularIngresoPatente() {
      this.patenteIngresoVerificada = true;
      this.patenteIngresoAlerta = Math.random() < 0.2;
    },
    generarPatente() {
      const letras = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
      const numeros = '0123456789';
      
      let letras1 = '';
      for (let i = 0; i < 2; i++) {
        letras1 += letras.charAt(Math.floor(Math.random() * letras.length));
      }
      
      let numerosPatente = '';
      for (let i = 0; i < 3; i++) {
        numerosPatente += numeros.charAt(Math.floor(Math.random() * numeros.length));
      }
      
      let letras2 = '';
      for (let i = 0; i < 2; i++) {
        letras2 += letras.charAt(Math.floor(Math.random() * letras.length));
      }
      
      return { letras1, numerosPatente, letras2 };
    },
    
    actualizarPatenteIngreso() {
      const patente = this.generarPatente();
      this.patenteIngresoLetras1 = patente.letras1;
      this.patenteIngresoNumeros = patente.numerosPatente;
      this.patenteIngresoLetras2 = patente.letras2;
      
      // 20% de probabilidad de que tenga alerta
      this.patenteIngresoAlerta = Math.random() < 0.2;
      
      // Registrar en consola para debugging
      console.log(`Patente de ingreso verificada: ${this.patenteIngresoLetras1}${this.patenteIngresoNumeros}${this.patenteIngresoLetras2}`);
      console.log(`Estado: ${this.patenteIngresoAlerta ? 'CON ALERTA' : 'Sin novedad'}`);
    },
    
    actualizarPatenteSalida() {
      const patente = this.generarPatente();
      this.patenteSalidaLetras1 = patente.letras1;
      this.patenteSalidaNumeros = patente.numerosPatente;
      this.patenteSalidaLetras2 = patente.letras2;
      
      // 20% de probabilidad de que tenga alerta
      this.patenteSalidaAlerta = Math.random() < 0.2;
      
      // Registrar en consola para debugging
      console.log(`Patente de salida verificada: ${this.patenteSalidaLetras1}${this.patenteSalidaNumeros}${this.patenteSalidaLetras2}`);
      console.log(`Estado: ${this.patenteSalidaAlerta ? 'CON ALERTA' : 'Sin novedad'}`);
    },
    
    iniciarSimulacionAutomatica() {
      // Actualizar patentes iniciales
      this.actualizarPatenteIngreso();
      this.actualizarPatenteSalida();
      
      // Configurar intervalos para actualizar cada 2 segundos
      setInterval(() => {
        this.actualizarPatenteIngreso();
      }, 2000);
      
      setInterval(() => {
        this.actualizarPatenteSalida();
      }, 2500); // Ligero desfase para que no cambien exactamente al mismo tiempo
    },
  },
  mounted() {
    this.iniciarSimulacionAutomatica();
  }
}
</script>

<style scoped>
.antecedentes-container {
  background-color: #f0f2f5;
  min-height: 100vh;
  padding: 16px;
}

.main-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.9);
  max-width: 1600px;
}

.gradient-header {
  background: linear-gradient(45deg, #3f51b5, #5c6bc0);
  color: white;
  border-radius: 0;
}

.search-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.search-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.search-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}

.search-button {
  transition: all 0.3s ease;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  height: 44px;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.results-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.results-title {
  background: linear-gradient(45deg, #3949ab, #5c6bc0);
  color: white;
  padding: 16px;
}

.bio-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.info-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.info-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}

.filters-panel {
  background-color: transparent;
}

.filters-header {
  font-weight: 500;
}

.loading-card {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-results-card {
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.car-avatar {
  background-color: #5c6bc0;
  color: white;
}

.control-san-carlos {
  margin-top: 20px;
  background: linear-gradient(135deg, #1a237e 0%, #283593 100%);
  border-radius: 12px;
  overflow: hidden;
}

.control-title {
  background-color: rgba(0, 0, 0, 0.2);
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.patente-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: none;
}

.patente-title {
  background-color: rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
  font-weight: bold;
}

.patente-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  padding: 20px 0;
}

.patente-argentina {
  width: 380px;
  height: 130px;
  background-color: #ffffff;
  border: 8px solid #000;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transition: transform 0.3s ease;
}

.patente-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #003399;
  color: white;
  height: 25px;
  padding: 0 8px;
  border-radius: 3px 3px 0 0;
}

.mercosur {
  font-size: 10px;
  font-weight: bold;
  color: white;
}

.republica {
  font-size: 14px;
  font-weight: bold;
  color: white;
  text-align: center;
  flex-grow: 1;
}

.bandera {
  width: 25px;
  height: 18px;
  background: linear-gradient(to bottom, #75AADB 33%, white 33%, white 66%, #75AADB 66%);
  position: relative;
  border-radius: 2px;
}

.bandera:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background-color: #FCB514;
  border-radius: 50%;
}

.patente-numero {
  font-size: 60px;
  font-weight: bold;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  letter-spacing: 2px;
  font-family: 'Arial', sans-serif;
  transition: all 0.3s ease;
}

.letras {
  font-size: 60px;
  font-weight: bold;
  color: #000;
}

.numeros {
  font-size: 60px;
  font-weight: bold;
  color: #000;
  margin: 0 5px;
}

.patente-alerta {
  animation: blink 1s infinite;
  color: #ff0000;
  text-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.patente-argentina:hover {
  transform: scale(1.02);
}

/* Estilos para pantallas pequeñas */
@media (max-width: 960px) {
  .main-card {
    border-radius: 0;
  }
  
  .search-card, .results-card {
    margin-bottom: 16px;
  }
}

/* Efectos de animación */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(63, 81, 181, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(63, 81, 181, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(63, 81, 181, 0);
  }
}

.search-button:focus {
  animation: pulse 1.5s infinite;
}
</style>
